module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-RegularItalic-470631497e3568c76a7ec931b4ea7999.woff2";